import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';
import { CollapsibleOptions } from './CollapsibleOptions';
import { buildUpdatePiecesRequest } from './helper';
import LabelSwitch from 'src/components/Inputs/LabelSwitch';

export const RequestDelivery = ({ mailpieces, actionStarted, onActionFinish, isForce }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();
  const [shouldNotifyMailroom, setShouldNotifyMailroom] = useState(false);

  const confirmAction = async () => {
    const requestData = buildUpdatePiecesRequest({
      mailpieces,
      action: PieceAction.RequestDelivery,
      isForce,
      shouldNotifyMailroom,
    });

    await updatePieces(requestData).unwrap();

    onActionFinish();
  };

  const content = (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {mailpieces.length === 1 ? (
          'Are you sure you would like this item to be delivered?'
        ) : (
          <>
            Are you sure you would like <strong>{mailpieces.length}</strong> items to be delivered?
          </>
        )}
      </Typography>

      {isForce && (
        <CollapsibleOptions>
          <Box sx={{ pt: 1 }}>
            <LabelSwitch
              checked={shouldNotifyMailroom}
              onChange={() => setShouldNotifyMailroom(!shouldNotifyMailroom)}
              label="Notify mailroom users about pending request"
            />
          </Box>
        </CollapsibleOptions>
      )}
    </Box>
  );

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Request delivery' : 'Request delivery for selected items'}
      content={content}
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Submit"
      cancelButtonTitle="Cancel"
    />
  );
};
